import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button/index";
import Typography from "@material-ui/core/Typography/index";
import {
	AgoraEventName,
	AppKey, BrowserEventName,
	ChatRoomJoinStatus,
	MobileChatType, Language, MessageContentType,
	PeerOnlineStatus,
	RTMConnectState, MeetingRole
} from "../utis/customEnum";
import RTCClient, {RTCPublishErrorName, RTCStreamInitErrorName, VideoCodec} from "../libs/agoraRtcClient";
import {Logger} from "../utis/Log";
import StreamPlayer from "agora-stream-player";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import clsx from "clsx";
import Consent from "./Consent";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import ChatStatus from "./ChatStatus";
import Call from "./Call";
import {Color} from "../utis/Styles";
import {API_TeletHealth, GetAPIBaseURL} from "../utis/API";
import HttpTool from "../utis/httpTool";
import {MD5Tool} from "../utis/cryptTool";
import RTMClient from "../libs/agoraRtmClient";
import {languagePackage} from "../utis/localStrings"
import {setRole} from "../utis/global";
import {GrayLog} from "../grayLog/grayLog";
import {LogEventName} from "../grayLog/logKey";
import {isDebug} from "../appConfig";

const MediaViewBaseZIndex = 1101
const DimensionsWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
const DimensionsHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
const LocalVideoWidth = 90
const LocalVideoHeight = 140
const captureScreenShotInterval = 60 //60s
const getSignUpCodeInterval = 30

class  MobileChat extends Component {
	constructor(props) {
		super(props)
		this.state = {
			remoteStream: null,
			localStream: null,
			isDialogVisible: false,
			isSpinnerVisible: false,
			isSnackbarVisible: false,
			isSignConsent: false,
			chatType: MobileChatType.consent,

			isVideoChat: true,
			isMute: false,

			videoDuration: 0,

			captureImageBase64Data: '',

			isSendInvitationRequest: false,
			sendInvitationRequestCounter: 60,
			isRequesting: false,
			isRegisterDialogVisible: false,
			isErrorDialogVisible: false,
			peerIsMuteVideo: false
		}

		this.meetingInfo = ''
		this.patientAccount = ''
		this.doctorAccount = ''
		this.channelName = ''
		this.sessionID = ''
		this.snackBarInfo = null
		this.dialogInfo = null
		this.isLoginSuccess = false

		this.isPatientRole = true

		this.patientName = ''
		this.doctorName = ''

		this.captureScreenShotCounter = 0
		this.timerCounterPeerSecond = 0
		this.isKickOff = false

		this.isHasSignUpVIPHealth = false
		this.signUpCode = ''
		this.isHasShowRegisterAlert = false
	}

	getMyAccount() {
		return this.isPatientRole ? this.patientAccount : this.doctorAccount
	}

	getPeerAccount() {
		return !this.isPatientRole ? this.patientAccount : this.doctorAccount
	}

	getRtmMyAccount() {
		return (this.getMyAccount() + '->' + this.getChatId())
	}

	getRtmPeerAccount() {
		return (this.getPeerAccount() + '->' + this.getChatId())
	}

	getChatId() {
		return this.channelName
	}

	getSessionID() {
		return this.sessionID
	}

	getChannelId() {
		let timeStamp = (new Date()).getTime()
		return MD5Tool.encrypt(this.getChatId()+ '' + timeStamp)
	}

	getMyFullName() {
		return !this.isPatientRole ? this.doctorName : this.patientName
	}

	getPeerFullName() {
		return this.isPatientRole ? this.doctorName : this.patientName
	}

	getMPatientID() {
		return this.mPatientId
	}

	getClinicID() {
		return this.clinicId
	}

	getGrayLogInfo(additionalInfo) {
		let base = {
			chatId: this.getChatId(),
			localId: this.getMyAccount(),
			peerId: this.getPeerAccount(),
			chatRole: this.isPatientRole ? 'pt' : 'dr',
			eventDate: this.getDateTimeStamp(),
			clinicId: this.clinicId || '',
			meetingInfo: this.meetingInfo || ''
		};

		if (typeof additionalInfo === 'object') {
			return Object.assign(base, additionalInfo);
		} else {
			return base;
		}
	}

	componentDidMount() {
		setRole(MeetingRole.patient)
		this.meetingInfo = this.props.match.params.meetingInfo

		this.addPageEventListener()
		this.getAppointmentInfo()

		if (!RTCClient.checkSystemRequirements()) {
			alert(languagePackage().BrowserNotSupport)
		}
	}

	componentWillUnmount() {
		this.clearGlobalTimer()
	}

	getAppointmentInfo() {
		let param = {
			EncryptData: this.meetingInfo
		}
		const { classes } = this.props

		this.showSpinner()
		HttpTool.post(API_TeletHealth.getMeetingInfo, param, (response) => {
			this.hideSpinner()
			if (response && response.AppointmentID) {
				let appointment = response
				this.patientName = appointment.PatientName
				this.doctorName = appointment.EmployeeName
				this.channelName = (appointment.AppointmentID + '-' + appointment.ClinicID)
				this.patientAccount = 'pt:' +  appointment.MPatientID
				this.doctorAccount = 'dr:' + appointment.MEmployeeID
				this.sessionID = appointment.SessionID
				this.isPatientRole = appointment.Role !== '0'
				this.mPatientId = appointment.MPatientID + ''
				this.clinicId = appointment.ClinicID + ''
				this.isHasSignUpVIPHealth = (appointment.VIPHealthSignUp === '1')

				let patientUserLanguage = response.PatientLanguage
				this.updateLanguagePackage(patientUserLanguage)

				GrayLog.updateCommon(this.getMyAccount());

				this.forceUpdate()
			}else {
				this.showDialog(
					languagePackage().GetMeetingInfoError,
					languagePackage().LogInFailedDesc,
					[
						<Button onClick={() => {
							this.hideDialog()
							window.location.reload();
						}} className={classes.baseButton} color="primary">
							{languagePackage().Reload}
						</Button>
					]
				)
			}
		}, (error) => {
			this.hideSpinner()

			this.showDialog(
				languagePackage().RequestFailed,
				languagePackage().LogInFailedDesc,
				[
					<Button onClick={() => {
						this.hideDialog()
						window.location.reload();
					}} className={classes.baseButton} color="primary">
						{languagePackage().Reload}
					</Button>
				]
			)
		})
	}

	updateLanguagePackage(patientUserLanguage) {
		if (patientUserLanguage === Language.chinese) {
			global.userLanguage = Language.chinese
		}else if (patientUserLanguage.indexOf(Language.spanish) !== -1) {
			global.userLanguage = Language.spanish
		}else {
			global.userLanguage = Language.english
		}
	}

	finishSignConsentAction() {
		this.addGlobalTimer()

		this.canJoinChatRoom((joinChatRoomStatus, chatId) => {
			if (joinChatRoomStatus === ChatRoomJoinStatus.canNotJoin && (this.getChatId() === chatId)) {
				const { classes } = this.props
				this.showDialog(
					languagePackage().Alert,
					languagePackage().ForceJoin,
					[
						<Button onClick={() => {
							window.open("about:blank", "_self");
							window.close();
						}} className={classes.baseButton} color="primary">
							{languagePackage().Cancel}
						</Button>,

						<Button className={classes.baseButton} onClick={() => {
							this.hideDialog()
							this.joinChatRoom((isJoinSuccess) => {
								if (isJoinSuccess) {
									this.loginWithRtm()
								}
							})
						}} color="primary">
							{languagePackage().Join}
						</Button>
					]
				)
			}else {
				this.joinChatRoom((isJoinSuccess) => {
					if (isJoinSuccess) {
						this.loginWithRtm()
					}
				})
			}
		})
	}

	loginWithRtm() {
		this.initRtmClient()
		this.loginAction()
	}

	joinChatRoom(cb) {
		let param = {
			chatId: this.getChatId(),
			userId: this.getMyAccount(),
			joinDate: this.getDateTimeStamp(),
			sessionID: this.getSessionID(),
			IsWeb : 1
		}

		this.showSpinner()
		HttpTool.post(API_TeletHealth.joinChatRoom, param, (response) => {
			this.hideSpinner()
			if (response?.resultCode === 1) {
				cb && cb(true)
				Logger.print("join chat successfully.")
			}else {
				cb && cb(false)
			}
			GrayLog.event(LogEventName.joinChatRoom, this.getGrayLogInfo({successful: response?.resultCode === 1}));
		},(error) => {
			this.hideSpinner()
			cb && cb(false)
			Logger.print('join chat fail')
			GrayLog.event(LogEventName.joinChatRoom, this.getGrayLogInfo({successful: false, errMsg: error?.message}));
		})
	}

	canJoinChatRoom(cb) {
		let param = {
			userId: this.getMyAccount(),
			chatId: this.getChatId(),
		}

		this.showSpinner()
		HttpTool.post(API_TeletHealth.canJoinChatRoom, param, (response) => {
			this.hideSpinner()
			Logger.print("Join status: " + JSON.stringify(response))
			if (response) {
				cb && cb(response.CanJoinChatRoom, response.ChatId)
			}else {
				cb && cb(false, '')
			}
		},(error) => {
			this.hideSpinner()
			Logger.print('can join chat fail')

			const { classes } = this.props
			this.showDialog(
				languagePackage().RequestFailed,
				languagePackage().LogInFailedDesc,
				[
					<Button onClick={() => {
						window.location.reload();
					}} className={classes.baseButton} color="primary">
						{languagePackage().Reload}
					</Button>
				]
			)
		})
	}

	leaveChatRoom(chatId, isKickOff = false, cb) {
		let param = {
			chatId: chatId,
			userId: this.getMyAccount(),
			leaveDate: this.getDateTimeStamp(),
			sessionID: this.getSessionID(),
			IsKickOff: isKickOff ? 1 : 0
		}

		HttpTool.post(API_TeletHealth.leaveChatRoom, param, (response) => {
			if (response?.resultCode === 1) {
				cb && cb(true)
				Logger.print("leave chat successfully.")
			}else {
				cb && cb(false)
			}
			GrayLog.event(LogEventName.leaveChatRoom, this.getGrayLogInfo({isKickOff: isKickOff, successful: response?.resultCode === 1}));
		},(error) => {
			Logger.print('leave chat fail')
			cb && cb(false)
			GrayLog.event(LogEventName.leaveChatRoom, this.getGrayLogInfo({isKickOff: isKickOff, successful: false, errMsg: error?.message}));
		})
	}

	sendBeaconToLeaveChatRoom() {
		if (this.isKickOff) {
			Logger.print("is Kick off, no need to call leave chat room")
			return
		}

		let leaveChatRoomParam = 'chatId=' + this.getChatId() + '&userId=' + this.getMyAccount() + '&leaveDate=' + this.getDateTimeStamp() + '&sessionID=' + this.getSessionID() + '&IsKickOff=0'

		const blob = new Blob([leaveChatRoomParam], { type: 'application/x-www-form-urlencoded' });
		navigator.sendBeacon(GetAPIBaseURL() + API_TeletHealth.leaveChatRoom, blob);
	}

	sendBeaconToEndVideo() {
		if (this.isKickOff) {
			Logger.print("is Kick off, no need to call leave end video")
			return
		}

		if (this.state.chatType === MobileChatType.video) {
			let endVideoParam = 'chatId=' + this.getChatId() + '&userId=' + this.getMyAccount() + '&endDate=' + this.getDateTimeStamp() + '&sessionID=' + this.getSessionID()
			const endVideoBlob = new Blob([endVideoParam], { type: 'application/x-www-form-urlencoded' });
			navigator.sendBeacon(GetAPIBaseURL() + API_TeletHealth.endVideo, endVideoBlob);
		}
	}

	beginVideo() {
		let param =  {
			chatId: this.getChatId(),
			userId: this.getMyAccount(),
			beginDate: this.getDateTimeStamp(),
			sessionID: this.getSessionID()
		}

		Logger.print("begin video param: " + JSON.stringify(param))
		HttpTool.post(API_TeletHealth.beginVideo, param, (response) => {
			if (response?.resultCode === 1) {
				Logger.print("begin video successfully.")
			}else {
				Logger.print("begin video fail.")
			}
			GrayLog.event(LogEventName.beginVideo, this.getGrayLogInfo({sessionId: this.getSessionID(), successful: response?.resultCode === 1}));
		}, (error) => {
			Logger.print('begin API error')
			GrayLog.event(LogEventName.beginVideo, this.getGrayLogInfo({sessionId: this.getSessionID(), successful: false, errMsg: error?.message}));
		})

		this.isVideoEnd = false;
	}

	endVideo() {
		if (this.isVideoEnd) { return; }
		this.isVideoEnd = true;

		let duration = this.state.videoDuration || 0;
		let param =  {
			chatId: this.getChatId(),
			userId: this.getMyAccount(),
			endDate: this.getDateTimeStamp(),
			sessionID: this.getSessionID()
		};

		Logger.print("end video param: " + JSON.stringify(param))
		HttpTool.post(API_TeletHealth.endVideo, param, (response) => {
			if (response?.resultCode === 1) {
				Logger.print("end video successfully.")
			}else {
				Logger.print("end video fail.")
			}
			GrayLog.event(LogEventName.endVideo, this.getGrayLogInfo({sessionId: this.getSessionID(), duration: duration, successful: response?.resultCode === 1}));
		}, (error) => {
			Logger.print('end API error')
			GrayLog.event(LogEventName.endVideo, this.getGrayLogInfo({sessionId: this.getSessionID(), duration: duration, successful: false, errMsg: error?.message}));
		})
	}

	getSignUpCode() {
		let param = {
			ClinicID: this.getClinicID(),
			MPatientID: this.getMPatientID()
		}

		this.showSpinner()
		HttpTool.post(API_TeletHealth.getSignUpCode, param, (response) => {
			this.hideSpinner()
			if(response && response.resultCode === 1 &&
				response.resultDescription && response.resultDescription) {
				this.signUpCode = response.resultDescription
			}
			Logger.print('sign up code:' + JSON.stringify(response))
			this.showRegisterDialog()
		}, (error) => {
			this.hideSpinner()
			Logger.print('error')
		})
	}

	getDateTimeStamp() {
		return (new Date()).toISOString()
	}

	formatVideoDuration(duration) {
		let hour = parseInt(((duration/3600) +''))
		let min = parseInt((duration%3600)/60 +'')
		let second = duration%60

		if (second < 10) {
			second = '0' + second
		}

		if (min < 10) {
			min = '0' + min
		}

		if (hour < 10) {
			hour = '0' + hour
		}

		return hour + ':' + min + ':' + second
	}

	initRtmClient() {
		this._rtmClient = new RTMClient(AppKey.AgoraAppKey, (eventName, event) => {
			if (eventName === AgoraEventName.MessageFromPeer) {
				Logger.print('MessageFromPeer: ' + JSON.stringify(event))
				if (!this.isPatientRole) {
					return
				}

				let chatRecord = JSON.parse(event.text)
				if (!chatRecord) {
					Logger.print('parse peer msg error: ' + event.text)
					return
				}

				let recordType = chatRecord.type ? chatRecord.type.toLowerCase() : chatRecord.type
				let contentType = MessageContentType.text

				if (recordType.indexOf(MessageContentType.jpg) !== -1) {
					contentType = MessageContentType.jpg
				} else if (recordType.indexOf(MessageContentType.jpeg) !== -1) {
					contentType = MessageContentType.jpeg
				} else if (recordType.indexOf(MessageContentType.png) !== -1) {
					contentType = MessageContentType.png
				}else if (recordType.indexOf(MessageContentType.pdf) !== -1) {
					contentType = MessageContentType.pdf
				}

				chatRecord.type = contentType
				this.logRecordMessage(chatRecord, this.getPeerAccount())

			}else if (eventName === AgoraEventName.LocalInvitationAccepted) {
				this.setState({chatType: MobileChatType.video},() => {
					this.beginVideo()
					this.joinChannel()
				})
			}else if (eventName === AgoraEventName.LocalInvitationReceivedByPeer) {
				this.setState({chatType: MobileChatType.makeCall})
			} else if (eventName === AgoraEventName.LocalInvitationCanceled) {
				this.setState({chatType: MobileChatType.canCall})
			}else if (eventName === AgoraEventName.LocalInvitationRefused) {
				this.setState({chatType: MobileChatType.canCall})
			}else if (eventName === AgoraEventName.LocalInvitationFailure) {
				this.setState({chatType: MobileChatType.canCall})
			}else if (eventName === AgoraEventName.RemoteInvitationReceived) {
				if (this.state.chatType === MobileChatType.receiveCall ||
					this.state.chatType === MobileChatType.video
				) {
					event && event.refuse()
				}else {
					this.channelId = event.channelId
					this.setState({chatType: MobileChatType.receiveCall})
				}
			}else if (eventName === AgoraEventName.RemoteInvitationCanceled) {
				this.setState({chatType: MobileChatType.canCall})
			}else if (eventName === AgoraEventName.RemoteInvitationRefused) {
				this.setState({chatType: MobileChatType.canCall})
			}else if (eventName === AgoraEventName.RemoteInvitationFailure) {
				this.setState({chatType: MobileChatType.canCall})
			}else if (eventName === AgoraEventName.ConnectionStateChanged) {
				Logger.print('connect status change event: ' + JSON.stringify(event))

				if (event === RTMConnectState.aborted) {
					Logger.print("connection is aborted now.")
					this.isKickOff = true
					this.clearGlobalTimer()

					if (this.state.chatType === MobileChatType.video) {
						this.endVideo()

						this.captureScreenShot(() => {
							this.timerCounterPeerSecond = 0
							this.endCall()
							this._rtcClient && this._rtcClient.leaveChannel(() => {
								this.setState({
									localStream: null,
									remoteStream: null,
									chatType: MobileChatType.consent,
									isMute: false,
									isVideoChat: true,
									peerIsMuteVideo: false,
								})
							})
						})
					}else {
						this.setState({
							localStream: null,
							remoteStream: null,
							chatType: MobileChatType.consent,
							isMute: false,
							isVideoChat: true,
							peerIsMuteVideo: false,
						})
					}

					this.leaveChatRoom(this.getChatId(), true,(isLeaveSuccess) => {
						if (isLeaveSuccess) {
							if (this._rtmClient && this._rtmClient.isLogined) {
								this._rtmClient.logout()
								this._rtmClient = null
							}

							const { classes } = this.props
							this.showDialog(
								languagePackage().LoginElseWhereTitle,
								languagePackage().LoginElseWhereDesc,
								[
									<Button onClick={() => {
										window.open("about:blank", "_self");
										window.close();
									}} className={classes.baseButton} color="primary">
										{languagePackage().Close}
									</Button>
								]
							)
						}
					})
				}else if (event === RTMConnectState.disconnected) {
					this.showSnackBar('Disconnected with server...', SnackBarVariantType.error, 2000)
				}else if (event === RTMConnectState.reconnecting) {
					this.showSnackBar('Reconnecting with server...', SnackBarVariantType.error, 2000)
				}
			}else if (eventName === AgoraEventName.PeersOnlineStatusChanged) {
				Logger.print('PeersOnlineStatusChanged event: ' + JSON.stringify(event))
				Logger.print('peer rtm account: ' + this.getRtmPeerAccount())
				if (event && (this.getRtmPeerAccount() in event)) {
					let newStatus = (event[this.getRtmPeerAccount()] === 'OFFLINE') ? PeerOnlineStatus.offline : PeerOnlineStatus.online

					Logger.print('newStatus: ' + newStatus)
					Logger.print("event[this.getRtmPeerAccount()] : " + event[this.getRtmPeerAccount()])
					//this.setState({isSendInvitationRequest: false, isRequesting: false})
					this.setState({
						chatType: newStatus === PeerOnlineStatus.online ? MobileChatType.canCall : MobileChatType.invite,
						peerOnlineStatus: newStatus,
						isSendInvitationRequest: false,
						isRequesting: false
					})
				}
			}
		})
	}

	logRecordMessage(chatRecord, peerAccount) {
		let param = {
			chatId: this.getChatId(),
			chatDate: this.getDateTimeStamp(),
			myAccount: this.getMyAccount(),
			peerAccount: peerAccount,
			content: chatRecord
		}

		HttpTool.post(API_TeletHealth.addChatMessageToMongoDB, param, (response) => {
			Logger.print('addTeleHealthMessageToMongoDB response: ' + JSON.stringify(response))
			if (response?.resultCode === 1) {
				Logger.print('log message to mongo success')
			}
		}, (error) => {
			Logger.print('addTeleHealthMessageToMongoDB: ' + JSON.stringify(error))
		})
	}

	loginAction() {
		this.login((isLoginSuccess) => {
			this.isLoginSuccess = isLoginSuccess
			if (isLoginSuccess) {
				this.showSnackBar(languagePackage().LoginSuccess, SnackBarVariantType.success, 2000)
			}else {
				const { classes } = this.props
				this.showDialog(
					languagePackage().LogInFailed,
					languagePackage().LogInFailedDesc,
					[
						<Button onClick={() => {
							this.hideDialog()
							this.loginAction()
						}} className={classes.baseButton} color="primary">
							{languagePackage().Login}
						</Button>
					]
				)
			}
		})
	}

	login(callback) {
		this.showSpinner()
		this._rtmClient.login(this.getRtmMyAccount(), (isSuccess) => {
			this.hideSpinner()
			Logger.print('login status: ' + isSuccess)
			if (isSuccess) {
				this._rtmClient.subscribePeersOnlineStatus([this.getRtmPeerAccount()])
			}

			callback && callback(isSuccess);
			GrayLog.event(LogEventName.loginRtmServer, this.getGrayLogInfo({account: this.getRtmMyAccount(), successful: isSuccess}));
		})
	}

	makeCall(rtmPeerAccount, channelId) {
		if (!this._rtmClient) {
			return;
		}

		this._rtmClient.makeCall(rtmPeerAccount, channelId)
	}

	cancelCall() {
		if (!this._rtmClient) {
			return;
		}

		this._rtmClient.cancelCall()
	}

	refuseCall() {
		if (!this._rtmClient) {
			return;
		}

		this._rtmClient.refuseCall()
	}

	acceptCall() {
		if (!this._rtmClient) {
			return;
		}

		this._rtmClient.acceptCall()
	}

	endCall() {
		if (!this._rtmClient) {
			return;
		}

		this._rtmClient.endCall()
	}

	addGlobalTimer() {
		this.globalTimerId = setInterval(() => {
			if (this.state.chatType === MobileChatType.video && this.state.remoteStream) {
				this.timerCounterPeerSecond = this.timerCounterPeerSecond + 1
				this.setState({videoDuration: this.timerCounterPeerSecond})

				// Logger.print("current: " + this.timerCounterPeerSecond + ' === ' + "next: " + (Math.pow(2,this.captureScreenShotCounter)*captureScreenShotInterval))
				if (this.timerCounterPeerSecond >= (Math.pow(2, this.captureScreenShotCounter)*captureScreenShotInterval)) {
					// Logger.print('addScreenShotTask saveScreenShot --- loop timer')
					this.captureScreenShot()
				}
			}else {
				this.timerCounterPeerSecond = 0
			}

			if (this.state.isSendInvitationRequest) {
				if (this.state.sendInvitationRequestCounter === 0) {
					this.setState({isSendInvitationRequest: false})
				}else {
					this.setState({sendInvitationRequestCounter: this.state.sendInvitationRequestCounter - 1})
				}
			}

			// Logger.print("timerCounterPeerSecond: " + this.timerCounterPeerSecond)
		}, 1000);
	}

	clearGlobalTimer() {
		this.globalTimerId && clearInterval(this.globalTimerId)
		this.globalTimerId = null
	}

	showSnackBar(title, variant, duration) {
		this.snackBarInfo = {}
		this.snackBarInfo.title = title
		this.snackBarInfo.variant = variant
		this.snackBarInfo.duration = duration

		this.setState({isSnackbarVisible: true})
	}

	addPageEventListener() {
		window.addEventListener(BrowserEventName.beforeunload, (event) => {
			this.destroyChatRoom()
		});
	}

	destroyChatRoom() {
		this.sendBeaconToEndVideo()
		if (this._rtmClient && this._rtmClient.isLogined) {
			this._rtmClient.logout()
			this._rtmClient = null
			this.sendBeaconToLeaveChatRoom()
		}

		for (let i =0; i < 1000000; i ++) {
			for (let j = 0; j < 1000; j ++) {
				;
			}
		}
	}

	hideSnackBar() {
		this.snackBarInfo = null
		this.setState({isSnackbarVisible: false})
	}

	isSafari() {
		let userAgent = navigator.userAgent.toLowerCase();
		return (userAgent.indexOf("safari") > -1) && (userAgent.indexOf("chrome") === -1) && (userAgent.indexOf("chromium") === -1)
	}

	joinChannel() {
		this.showSpinner()
		Logger.print("channel Name: " + this.channelId)

		let codec = this.isSafari() ? VideoCodec.h264 : VideoCodec.vp9
		this._rtcClient = new RTCClient(this.channelId, codec, (eventName) => {
			Logger.print('rtc event name: ' + eventName)
			this.hideSpinner()
			if (eventName === AgoraEventName.StreamPublished) {
				this.setState({localStream: this._rtcClient.localStream})
			}else if (eventName === AgoraEventName.StreamSubscribed) {
				this.showSnackBar(languagePackage().JoinVideoChat, SnackBarVariantType.info, 3000)
				setTimeout(() => {
					this.setState({remoteStream: this._rtcClient.remoteStream})
				}, 2500)
			}else if (eventName === AgoraEventName.PeerLeave) {
				Logger.print('peer live leave rtc channel....')

				if (!this.isKickOff) {
					this.endVideo()
					this.leaveChatRoom(this.getChatId(), false, () => {})
				}

				this.captureScreenShot(() => {
					if (!this.isHasShowRegisterAlert && this.isPatientRole && !this.isHasSignUpVIPHealth) {
						this.isHasShowRegisterAlert = true
						if (this.timerCounterPeerSecond >= getSignUpCodeInterval) {
							this.getSignUpCode()
						}else {
							this.showRegisterDialog()
						}
					}

					this.timerCounterPeerSecond = 0
					this.endCall()
					this._rtcClient && this._rtcClient.leaveChannel(() => {
						this.setState({
							localStream: null,
							remoteStream: null,
							chatType: MobileChatType.canCall,
							isMute: false,
							isVideoChat: true,
							peerIsMuteVideo: false,
							videoDuration: this.timerCounterPeerSecond
						})
					})
				})
			}else if (eventName === AgoraEventName.muteAudio) {

			}else if (eventName === AgoraEventName.unmuteAudio) {

			}else if (eventName === AgoraEventName.muteVideo) {
				this.setState({peerIsMuteVideo: true})
			}else if (eventName === AgoraEventName.unmuteVideo) {
				this.setState({peerIsMuteVideo: false})
			}
		})

		this._rtcClient.joinChannel((error) => {
			if (error) {
				const {name, message} = error
				GrayLog.error({message: `${name} - ${message}`}, this.getGrayLogInfo())
				if (name === RTCStreamInitErrorName.deviceNotFound) {
					alert(languagePackage().CheckDeviceAndPermission)
				} else if (name === RTCPublishErrorName.invalidOperation && name === RTCPublishErrorName.requestAbort) {
					alert(languagePackage().ConnectionDisconnectedAndTryAgain)
				} else if (name === RTCStreamInitErrorName.notAllowed) {
					this.setState({isErrorDialogVisible: true})
				} else {
					alert(`${name} - ${message}`)
				}
			} else {
				alert("Unexpected Error. Please contact digitalhealth@mdland.com")
			}
		})
	}

	captureScreenShot(callback) {
		if (!this._renderStreamCanvas) {
			callback && callback()
			return;
		}

		// for remote
		let remoteStreamContext = this._renderStreamCanvas.getContext('2d');
		this._renderStreamCanvas.setAttribute('width', DimensionsWidth);
		this._renderStreamCanvas.setAttribute('height', DimensionsHeight);

		// for remote
		if (this.state.remoteStream) {
			let remoteVideo = document.getElementById('video' + this.state.remoteStream.getId());
			if (remoteVideo) {
				remoteStreamContext.clearRect(0, 0, this._renderStreamCanvas.width, this._renderStreamCanvas.height)
				remoteStreamContext.drawImage(remoteVideo, 0, 0, this._renderStreamCanvas.width, this._renderStreamCanvas.height);
			}
		}

		// for local
		if (this.state.localStream) {
			let localVideo = document.getElementById('video' + this.state.localStream.getId());
			if (localVideo) {
				remoteStreamContext.drawImage(localVideo, DimensionsWidth - LocalVideoWidth - 20, 20, LocalVideoWidth, LocalVideoHeight);
			}
		}

		remoteStreamContext.font = "18px Arial";
		remoteStreamContext.fillStyle = "#ff0000";
		remoteStreamContext.textAlign = "center";
		remoteStreamContext.fillText(this.formatVideoDuration(this.state.videoDuration), this._renderStreamCanvas.width/2.0, 30,)

		let muteImage = (this.state.isMute ? require('../assets/images/audio_mute.png') : require('../assets/images/audio_unmute.png'))
		let endCallImage = require('../assets/images/reject.png')
		let videoImage = (this.state.isVideoChat ? require('../assets/images/video_voice.png') : require('../assets/images/video_video.png'))

		this.canvasDrawImage(muteImage, (muteImageRef) => {
			if (muteImageRef) {
				remoteStreamContext.drawImage(muteImageRef, (DimensionsWidth - 60*3)/4.0, DimensionsHeight - 90, 60, 60)
			}

			this.canvasDrawImage(endCallImage, (endCallImageRef) => {
				if (endCallImageRef) {
					remoteStreamContext.drawImage(endCallImageRef, (DimensionsWidth/2.0) - 30, DimensionsHeight - 90, 60, 60)
				}

				this.canvasDrawImage(videoImage, (videoImageRef) => {
					if (videoImageRef) {
						remoteStreamContext.drawImage(videoImageRef, DimensionsWidth - 60 - (DimensionsWidth - 60*3)/4.0, DimensionsHeight - 90, 60, 60)
					}

					this.saveScreenShot(this._renderStreamCanvas, callback)
				})
			})
		})
	}

	saveScreenShot(canvas, callback) {
		if (!canvas) {
			return;
		}

		let imageData = canvas.toDataURL('image/jpeg')
		// this.setState({captureImageBase64Data: imageData})
		let imageDataInfo = imageData.split(',')
		if (imageDataInfo && imageDataInfo.length === 2) {
			let base64Data = imageDataInfo[1]
			this.uploadScreenShot(base64Data)
		}

		this.captureScreenShotCounter = this.captureScreenShotCounter + 1
		callback && callback()
		this.clearCanvas()
	}

	canvasDrawImage(src,callback) {
		let image = new Image()

		image.src = src
		image.onload= (() => {
			callback && callback(image)
		})
		image.onerror=(() => {
			callback && callback(null)
		})
	}

	clearCanvas() {
		this._renderStreamCanvas && this._renderStreamCanvas.setAttribute('width', 0);
	}

	uploadScreenShot(photoBase64) {
		let param = JSON.stringify({
			chatId: this.getChatId(),
			shotDate: this.getDateTimeStamp(),
			photo: photoBase64
		})

		Logger.print("save screen shot param: " + JSON.stringify(param))
		HttpTool.post(API_TeletHealth.addChatScreenShot, param, (response) => {
			Logger.print('addTeleHealthScreenShot response: ' + JSON.stringify(response))
			if (response?.resultCode === 1) {

			}
		}, (error) => {

		})
	}

	renderStreamCanvas() {
		const { classes } = this.props

		return (
			<canvas className={classes.streamCanvasContainer} ref={(o) => {
				this._renderStreamCanvas = o
			}} />
		)
	}

	renderLocalStream() {
		const { classes } = this.props

		return (
			<div className={classes.localStreamContainer}>
				{this.state.localStream ?
				<StreamPlayer
					video={this.state.isVideoChat}
					audio={!this.state.isMute}
					stream={this.state.localStream}
					fit="cover"
					placeholder={
						<div style = {{
							backgroundColor: Color.black,
							width: '100%',
							height: '100%',
						}}>

						</div>
					}
					style={{
						width: LocalVideoWidth,
						height: LocalVideoHeight,
						position: 'absolute',
						backgroundColor: '#ffffff'
					}}
				/>
				: null}
			</div>
		)
	}

	renderRemoteStream() {
		const { classes } = this.props

		return (
			<div className={classes.remoteStreamContainer}>
				{this.state.remoteStream ?
				<StreamPlayer
					video={this.state.isVideoChat}
					audio={true}
					stream={this.state.remoteStream}
					fit="cover"
					placeholder={
						<div style = {{
							backgroundColor: Color.black,
							width: '100%',
							height: '100%',
						}}>
							{this.renderVoiceChatHolder()}
						</div>
					}
					style={{
						width: '100%',
						height: '100%',
						backgroundColor: '#ffffff'
					}}
				/>
				: null}

				{/*{!this.state.remoteStream ? this.renderWaitPeerJoinDesc() : null}*/}
			</div>
		)
	}

	renderWaitPeerJoinDesc() {
		return(
			<Typography  variant="h6" gutterBottom>
				Joining the chat, Please wait...
			</Typography>
		)

	}

	renderVoiceChatHolder() {
		return(
			<Typography gutterBottom>
				Voice chat
			</Typography>
		)
	}

	showSpinner() {
		this.setState({isSpinnerVisible: true})
	}

	hideSpinner() {
		this.setState({isSpinnerVisible: false})
	}

	sendMessageToPeer() {
		this.showSpinner()
		setTimeout(() => {
			this.hideSpinner()

		}, 2000)
	}

	showDialog(title, desc, actions) {
		this.dialogInfo = {
			title: '',
			desc: '',
			actions: []
		}
		this.dialogInfo.title = title
		this.dialogInfo.desc = desc
		this.dialogInfo.actions = actions
		this.setState({isDialogVisible: true})
	}

	hideDialog() {
		this.setState({isDialogVisible: false})
	}

	setMute() {
		this.setState({isMute: !this.state.isMute})
	}

	setVideo() {
		this.setState({isVideoChat: !this.state.isVideoChat})
	}

	sendInviteSMS() {
		let param = {
			EncryptData: this.meetingInfo
		}

		this.showSpinner()
		this.setState({isRequesting: true})
		HttpTool.post(API_TeletHealth.invitePatientToChatBySMS, param, (response) => {
			this.setState({isRequesting: false})
			this.hideSpinner()
			if (response && response.resultCode === 1) {
				this.setState({isSendInvitationRequest: true, sendInvitationRequestCounter: 60})
			}else {
				const { classes } = this.props
				let title = languagePackage().SendInviteFailedTitle
				let desc = languagePackage().SendInviteFailedDesc
				this.showDialog(
					title,
					desc,
					[
						<Button onClick={() => {
							this.setState({isShowDialog: false})
						}} className={classes.baseButton} color="primary">
							{languagePackage().OK}
						</Button>,
					]
				)
			}
			GrayLog.event(LogEventName.sendChatInvites, this.getGrayLogInfo({successful: response?.resultCode === 1}));
		}, (error) => {
			this.hideSpinner()
			this.setState({isRequesting: false})
			this.showSnackBar('An error occurred', SnackBarVariantType.info, 2000)
			GrayLog.event(LogEventName.sendChatInvites, this.getGrayLogInfo({successful: false, errMsg: error?.message}));
		})
	}

	showRegisterDialog() {
		this.setState({isRegisterDialogVisible: true})
	}

	renderToolbar() {
		if (!this.state.remoteStream) {
			return null
		}

		const { classes } = this.props

		return (
			<div className={classes.toolbarContainer}>
				<Button onClick={() => {
					this.setMute()
				}} className={classes.toolbarBaseButton} color="primary">
					<img alt={'mute'} style={{width: 60, height: 60}}  src={this.state.isMute ?  require('../assets/images/audio_mute.png') : require('../assets/images/audio_unmute.png')} />
				</Button>

				<Button onClick={() => {
					this.endVideo()
					this.leaveChatRoom(this.getChatId(), false, () => {})

					this.captureScreenShot(() => {
						if (!this.isHasShowRegisterAlert && this.isPatientRole && !this.isHasSignUpVIPHealth ) {
							this.isHasShowRegisterAlert = true
							if (this.timerCounterPeerSecond > getSignUpCodeInterval) {
								this.getSignUpCode()
							}else {
								this.showRegisterDialog()
							}
						}

						this.timerCounterPeerSecond = 0
						this.endCall()
						this._rtcClient && this._rtcClient.leaveChannel(() => {
							this.setState({
								localStream: null,
								remoteStream: null,
								chatType: MobileChatType.canCall,
								isMute: false,
								isVideoChat: true,
								peerIsMuteVideo: false,
								videoDuration: this.timerCounterPeerSecond
							})
						})
					})
				}} className={classes.toolbarBaseButton} color="primary">
					<img alt={'video'} style={{width: 60, height: 60}} src={require('../assets/images/reject.png')} />
				</Button>

				<Button onClick={() => {
					this.setVideo()
				}} className={classes.toolbarBaseButton} color="primary">
					<img alt={'video'} style={{width: 60, height: 60}} src={this.state.isVideoChat ? require('../assets/images/video_voice.png') :
						require('../assets/images/video_video.png')
					} />
				</Button>
			</div>
		)
	}

	renderVideoDuration() {
		return(
			<Typography style={{width: '100%', top: 15, textAlign: 'center',
				color: Color.red, fontSize: 18, position: 'absolute',
				left: 0, zIndex: MediaViewBaseZIndex + 1
			}}>
				{this.formatVideoDuration(this.state.videoDuration)}
			</Typography>
		)
	}

	renderSpinner() {
		return (
			<Dialog
				open={this.state.isSpinnerVisible}
				onClose={() => {

				}}
			>
				<DialogContent>
					<div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
						<CircularProgress size={20}/>
						<Typography style={{marginTop: 10}}>{languagePackage().Loading}</Typography>
					</div>

				</DialogContent>
			</Dialog>
		)
	}

	openFAQ() {
		const url = window.location.origin
		window.location = `${url}/#/faq`
	}

	openVIPHealthApp(registerCode = '') {
		const host = isDebug ? "https://static-app.iclinichealth.dev" : "https://static-app.iclinichealth.com"
		window.location = `${host}/#/oa?src=6&rg=${registerCode}`;
	}

	openAppStore(isIOS) {
		let appStoreUrl = ''

		if (isIOS) {
			appStoreUrl = 'https://itunes.apple.com/us/app/viphealth/id1265405734?mt=8'
		}else {
			appStoreUrl = 'https://play.google.com/store/apps/details?id=com.react_viphealth'
		}

		if (isIOS) {
			window.location = appStoreUrl
		}else {
			window.open(appStoreUrl);
		}
	}

	renderRegisterDialog() {
		const { classes } = this.props
		let code = this.signUpCode

		return (
			<Dialog
				open={this.state.isRegisterDialogVisible}
				onClose={() => {

				}}
			>
				<DialogContent>
					<div style={{display: 'flex', alignItems: 'center', flexDirection: 'column',}}>
						<img style={{width: 60, height: 60,}} src={require('../assets/images/logo.png')} alt={""}/>
						{code && code.length ? (<div style={{marginTop: 25}}>
							<Typography style={{display: 'inline', color: Color.black, fontSize: 18}}>
								{languagePackage().RegisterComment1}
							</Typography>
							<Typography style={{display: 'inline', color: Color.theme, fontSize: 20,}}>
								{code}
							</Typography>
							<Typography style={{display: 'inline', color: Color.black, fontSize: 18}}>
								{languagePackage().RegisterComment2}
							</Typography>
						</div>) : <Typography style={{marginTop: 25,}}>
							{languagePackage().RegisterComment}
						</Typography>}

						<Button onClick={() => {
							this.openVIPHealthApp(code)
						}} className={classes.registerButton} variant="outlined">
							{languagePackage().Register}
						</Button>

						<div style={{display: 'flex',justifyContent: 'flex-end', flexDirection: 'row', width: '100%', position: 'absolute', left: 0,
							right: 0, top: 0, height: 50
						}}>
							<Button onClick={() => {
								this.setState({isRegisterDialogVisible: false})
							}} style={{marginTop: 8}}>
								<img style={{width: 24, height: 24}} src={require('../assets/images/close.png')} alt={""}/>
							</Button>
						</div>

					</div>
				</DialogContent>
			</Dialog>
		);
	}

	renderSnackBar() {
		const { classes } = this.props

		if (!this.snackBarInfo) {
			return null
		}

		let variant = this.snackBarInfo.variant ?  this.snackBarInfo.variant : 'success'
		let duration = this.snackBarInfo.duration ? this.snackBarInfo.duration : 4000

		return(
			<Snackbar
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'center',
					backgroundColor: 'blue'
				}}
				open={this.state.isSnackbarVisible}
				autoHideDuration={duration}
				onClose={() => {
					this.hideSnackBar()
				}}
			>
				<SnackbarContent
					className={clsx(classes[variant])}
					aria-describedby="client-snackbar"
					message={
						<span id="client-snackbar" className={classes.snackbarMessage}>
							{this.snackBarInfo.title}
        				</span>
					}
				/>
			</Snackbar>
		)
	}

	renderDialog() {
		if (!this.dialogInfo) {
			return
		}

		let title = this.dialogInfo.title
		let desc = this.dialogInfo.desc
		let actions = this.dialogInfo.actions
		const { classes } = this.props

		if (!actions || !actions.length) {
			actions.push(<Button onClick={() => {
				this.setState({isDialogVisible: false})
			}} className={classes.baseButton} color="primary">
				Cancel
			</Button>)
		}

		return(
			<Dialog
				open={this.state.isDialogVisible}
				onClose={() => {

				}}
			>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					{desc}
				</DialogContent>
				<DialogActions>
					{actions}
				</DialogActions>
			</Dialog>
		)
	}

	renderConsentPage() {
		return (
			<Consent
				signAction={(isPatientRole) => {
				if (!this.meetingInfo || !this.meetingInfo.length) {
					this.showSnackBar('Meeting info is invalid.', SnackBarVariantType.error, 4000)
					return
				}
				this.setState({isSignConsent: true})
				setTimeout(() => {
					this.finishSignConsentAction()
				}, 200)
			}}/>
		)
	}

	renderMuteVideoTipsView() {
		const { classes } = this.props

		if (this.state.remoteStream && this.state.peerIsMuteVideo) {
			return(
				<div className={classes.muteVideoContainer}>
					<Typography className={classes.muteTips} variant="h5" gutterBottom>
						{languagePackage().TheVideoIsMuteByPeer}
					</Typography>
				</div>
			)
		}else if (this.state.remoteStream && !this.state.isVideoChat) {
			return(
				<div className={classes.muteVideoContainer}>
					<Typography className={classes.muteTips} variant="h5" gutterBottom>
						{languagePackage().VoiceChat}
					</Typography>
				</div>
			)
		}

		return null
	}

	renderChatPage() {
		const { classes } = this.props
		return(
			<div className={classes.container}>
				{this.renderStreamCanvas()}
				{this.renderRemoteStream()}
				{this.renderLocalStream()}

				{this.renderMuteVideoTipsView()}

				{this.renderToolbar()}
				{this.renderVideoDuration()}
			</div>
		)
	}

	renderChatStatusPage() {
		let title =  ''
		let counting = false
		let chatType = this.state.chatType
		if (chatType === MobileChatType.invite) {
			title =  this.state.isSendInvitationRequest ?  (this.state.sendInvitationRequestCounter + 's') :  languagePackage().Invite + this.getPeerFullName()
			counting = this.state.isSendInvitationRequest
		}else {
			title = languagePackage().Call + this.getPeerFullName()
		}

		return(
			<ChatStatus
				counting = {counting}
				title = {title}
				chatType = {chatType}
				peerName = {this.getPeerFullName()}
				isPatientRole={this.isPatientRole}
				clickAction={(chatType, peerName) => {
					if (chatType === MobileChatType.invite && !this.isPatientRole) {
						if (!this.state.isSendInvitationRequest && !this.state.isRequesting) {
							this.sendInviteSMS()
						}
					}else if (chatType === MobileChatType.canCall) {
						if (this.state.peerOnlineStatus === PeerOnlineStatus.online &&
							this.state.chatType === MobileChatType.canCall
						) {
							this.channelId = this.getChannelId()
							this.makeCall(this.getRtmPeerAccount(), this.channelId)

							this.setState({chatType: MobileChatType.makeCall})
						}
					}
			}}/>
		)
	}

	renderCallPage() {
		return(
			<Call
				chatType = {this.state.chatType}
				peerName = {this.getPeerFullName()}
				cancelCall={() => {
					Logger.print('cancel call')
					this.setState({chatType: MobileChatType.canCall})
					this.cancelCall()
				}}
				refuseCall={() => {
					Logger.print('refuse call')
					this.setState({chatType: MobileChatType.canCall})
					this.refuseCall()
				}}
				acceptCall={() => {
					Logger.print('accept call')
					this.acceptCall()
					this.setState({chatType: MobileChatType.video},() => {
						Logger.print('add fist screen shot ---')
						this.beginVideo()
						this.captureScreenShot(() => {
							this.timerCounterPeerSecond = 0
							this.captureScreenShotCounter = 0
						})

						this.joinChannel()
					})
				}}
			/>
		)
	}

	renderPageWithMobileChatType() {
		let chatType = this.state.chatType

		if (chatType === MobileChatType.consent) {
			return this.renderConsentPage()
		}else if (chatType === MobileChatType.invite || chatType === MobileChatType.canCall) {
			return this.renderChatStatusPage()
		} else if (chatType === MobileChatType.makeCall || chatType === MobileChatType.receiveCall) {
			return this.renderCallPage()
		}else if (chatType === MobileChatType.video) {
			return this.renderChatPage()
		}
	}

	renderLockIcon() {
		return (
			<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1.78571 4.28571V3.21429C1.78571 1.43906 3.22545 0 5 0C6.77455 0 8.21429 1.43906 8.21429 3.21429V4.28571H8.57143C9.35938 4.28571 10 4.92634 10 5.71429V10C10 10.7879 9.35938 11.4286 8.57143 11.4286H1.42857C0.639509 11.4286 0 10.7879 0 10V5.71429C0 4.92634 0.639509 4.28571 1.42857 4.28571H1.78571ZM3.21429 4.28571H6.78571V3.21429C6.78571 2.22812 5.98661 1.42857 5 1.42857C4.01339 1.42857 3.21429 2.22812 3.21429 3.21429V4.28571Z" fill="black"/>
			</svg>
		)
	}

	renderErrorDialog() {
		const { classes } = this.props

		return (
			<Dialog
				open={this.state.isErrorDialogVisible}
				onClose={() => {}}
			>
				<DialogContent>
					<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
						<span style={{fontSize: 18, fontWeight: 600, color: '#365496', marginRight: 40}}>{"Having trouble with Telehealth?"}</span>
						<span style={{fontSize: 14, fontWeight: 400, color: '#263B69', marginTop: 6}}>{"Try the following troubleshooting steps:"}</span>
						<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 16}}>
							<span style={{fontSize: 16}}>
								{`1. Click on the `}
								{this.renderLockIcon()}
								{` icon beside your address bar.`}
							</span>
							<span style={{fontSize: 16, marginTop: 6}}>2. Click on <span style={{fontWeight: 700}}>Permissions</span> and enable <span style={{fontWeight: 700}}>camera, microphone</span> and <span style={{fontWeight: 700}}>sound</span>.</span>
							<span style={{fontSize: 16, marginTop: 6}}>3. If the issue persists, go to settings, go to <span style={{fontWeight: 700}}>Notification</span> and turn off <span style={{fontWeight: 700}}>Bubbles</span>.</span>
							<span style={{fontSize: 16, marginTop: 6}}>{"4. Reload this page."}</span>
						</div>

						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
							<Button onClick={() => {
								this.openFAQ()
							}} className={classes.registerButton} variant="outlined">
								{"See Full FAQ"}
							</Button>
						</div>

						<div style={{display: 'flex',justifyContent: 'flex-end', flexDirection: 'row', width: '100%', position: 'absolute', left: 0,
							right: 0, top: 0, height: 50
						}}>
							<Button onClick={() => {
								this.setState({isErrorDialogVisible: false})
							}} style={{marginTop: 8}}>
								<img style={{width: 24, height: 24}} src={require('../assets/images/close.png')} alt={""}/>
							</Button>
						</div>

					</div>
				</DialogContent>
			</Dialog>
		)
	}

	render() {
		const { classes } = this.props
		return(
			<div className={classes.root}>
				{this.renderPageWithMobileChatType()}
				{this.renderSpinner()}
				{this.renderSnackBar()}
				{this.renderDialog()}
				{this.renderRegisterDialog()}
				{this.renderErrorDialog()}
			</div>
		)
	}
}

const styles = (theme) => ({
	root: {
		width: '100%',
		height: '100%',
		backgroundColor: '#ffff00',
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	container: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	remoteStreamContainer: {
		width: '100%',
		height: '100%',
		backgroundColor: '#ffffff',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},

	muteVideoContainer: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		backgroundColor: '#000000',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: MediaViewBaseZIndex
	},

	muteTips: {
		color: Color.white,
		marginLeft: 10,
		marginRight: 10,
		textAlign: 'center'
	},

	streamCanvasContainer: {
		left: 0,
		top: 0,
		position: 'absolute',
		width: DimensionsWidth,
		height: DimensionsHeight,
		overflow: 'hidden',
		backgroundColor: Color.white
	},
	localStreamContainer: {
		width: 90,
		height: 140,
		position: 'absolute',
		top: 20,
		right: 20,
		backgroundColor: '#ffffff',
	},
	toolbarContainer: {
		width: '100%',
		height: 100,
		position: 'absolute',
		left: 0,
		bottom: 0,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-around',
		backgroundColor: 'rgba(0,0,0, 0.3)',
		zIndex: MediaViewBaseZIndex + 1
	},
	toolbarBaseButton: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		overflow: 'hidden'
	},
	snackbarMessage: {
		display: 'flex',
		alignItems: 'center',
	},
	toolbarVolButton: {
		height: 44,
		width: 44,
		color: '#ffffff'
	},
	success: {
		backgroundColor: green[600],
	},
	error: {
		backgroundColor: theme.palette.error.dark,
	},
	info: {
		backgroundColor: theme.palette.primary.main,
	},
	warning: {
		backgroundColor: amber[700],
	},
	baseButton: {
		fontSize: 18,
	},
	registerCloseButton: {
		width: 30,
		height: 30,
	},
	registerCloseButtonImage: {
		width: 30,
		height: 30,
	},
	registerButton: {
		width: 175,
		color: Color.theme,
		height: 40,
		marginTop: 25,
		borderRadius: 6,
		borderWidth: 1,
		borderColor: Color.theme,
		marginBottom: 10,
		fontSize: 16,
	}
})

const SnackBarVariantType = {
	success: 'success',
	error: 'error',
	info: 'info',
	warning: 'warning',
}

export default withStyles(styles)(MobileChat)
